<template>
  <div>
    <section class="mb-4 mb-lg-5">
      <div class="container">
        <div class="image-header" :style="coverImage">
          <label for="cover" class="btn btn-outline-color2">Adicionar imagem</label>
          <input
            type="file"
            name="cover"
            id="cover"
            style="display: none"
            @change="changeCover"
            accept="image/*"
          />
        </div>
      </div>
    </section>
    <section class="mb-5">
      <div class="container text-center">
        <div class="col-lg-10 mx-auto">
          <form
            action=""
            method="POST"
            @submit.prevent="submit"
          >
            <div class="form-group mb-4">
              <input
                type="text"
                class="form-control font-weight-bold font-size-medium bordered-bottom"
                name="name"
                placeholder="Nome da categoria"
                v-model.trim="$v.category.name.$model"
                @blur="setSlug"
              />
            </div>
            <div class="form-group mb-4 col-md-6 mx-md-auto editable-form">
              <span>{{ baseUrl }}/{{ user ? user.username : '' }}/c/</span>
              <input
                class="form-control bordered-bottom font-size-small pb-0 text-left"
                name="slug"
                placeholder="URL"
                v-model.trim="category.slug"
              />
            </div>
            <div class="form-group mb-5 col-md-6 mx-md-auto">
              <textarea
                type="text"
                class="form-control bordered-bottom font-size-small w-100"
                name="description"
                placeholder="Descrição da categoria"
                v-model.trim="category.description"
              ></textarea>
            </div>
            <div class="form-group mt-5">
              <Button
                class="btn-primary"
                type="submit"
                :disabled="$v.$invalid"
                :loading="loader"
              >
                Salvar
              </Button>
              <router-link
                class="btn btn-outline-color2 ml-3"
                :to="{ name: 'categories.index' }"
              >
                Voltar
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import CategoriesService from '@/modules/categories/services/categories-service'
import { required } from 'vuelidate/lib/validators'
import variables from '@/mixins/variables'
import { slugify } from '@/utils'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'

export default {
  mixins: [variables],
  components: {
    Button
  },
  data () {
    return {
      loader: false,
      category: {
        name: '',
        slug: '',
        description: '',
        cover: null
      }
    }
  },
  metaInfo: {
    title: 'Criar categoria'
  },
  validations () {
    return {
      category: {
        name: { required }
      }
    }
  },
  computed: {
    coverImage () {
      return {
        backgroundImage: this.category.cover ? `url('${URL.createObjectURL(this.category.cover)}')` : `url('${this.noCoverUrl}')`
      }
    },
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    changeCover (e) {
      const file = e.target.files[0]
      this.category.cover = file
    },
    setSlug () {
      if (!this.category.slug) {
        this.category.slug = slugify(this.category.name)
      }
    },
    async submit () {
      this.loader = true
      try {
        const category = await CategoriesService.postCategory(null, this.category)
        return this.$router.push({ name: 'categories.show', params: { username: category.user.username, slug: category.slug } })
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
